import { HomeOutlined, LoginOutlined, MenuOutlined } from "@ant-design/icons";
import { Button, Drawer, Menu } from "antd";
import React, { useState } from "react";
import img from '../../assets/img.svg';
import { FaClipboardList, FaEnvelope, FaUser } from "react-icons/fa";
import { HEADER_TITLE } from "../properties/properties";
import './MobileMenuHeader.css';
import { Header } from "antd/es/layout/layout";

const MobileMenuHeader = ({handleMenuClick}) => {

    const [isMenuDrawerOpen, setIsMenuDrawerOpen] = useState(false);

    function mobileMenu(menuItem) {
        handleMenuClick(menuItem);
        setIsMenuDrawerOpen(false);
    };

    return(
        <>
        <Header className="mobile-app-header">
            <img src={img} alt="Logo" className='mobile-logo'/>
            <div theme="dark" className='maintitle'>
                {HEADER_TITLE}
            </div>
            <div>
                <Button
                    icon={<MenuOutlined />}
                    onClick={() => setIsMenuDrawerOpen(true)}></Button>
                <Drawer
                    open={isMenuDrawerOpen}
                    title="Menu"
                    width="60%"
                    onClose={() => setIsMenuDrawerOpen(false)}
                >
                    <Menu mode='vertical' theme='light' defaultSelectedKeys={['1']}>
                        <Menu.Item icon={<HomeOutlined />} onClick={() => mobileMenu("Home")}>
                            Home
                        </Menu.Item>
                        <Menu.Item icon={<FaUser />} onClick={() => mobileMenu("About")}>
                            About
                        </Menu.Item>
                        <Menu.Item icon={<FaClipboardList />} onClick={() => mobileMenu("Services")}>
                            Services
                        </Menu.Item>
                        <Menu.Item icon={<FaEnvelope />} onClick={() => mobileMenu("Contact")}>
                            Contact us
                        </Menu.Item>
                        <Menu.Item icon={<LoginOutlined />} >
                            Login
                        </Menu.Item>
                    </Menu>
                </Drawer>
            </div>    
        </Header>
        </>
    )};
export default MobileMenuHeader;